module.exports = __webpack_public_path__ + "img/freeipa.cd488d20.svg";